import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.css'],
    standalone: false
})
export class HowItWorksComponent implements OnInit {
  isMobileView = false;
  subscription: Subscription;
  showPDF = true; // Set to false to show HTML content instead
  
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

